export const AMPLIFY_CONFIG = {
  Auth: {
    region: import.meta.env.VITE_REACT_APP_AMPLIFY_REGION,
    userPoolId: import.meta.env.VITE_REACT_APP_AMPLIFY_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_REACT_APP_AMPLIFY_APP_CLIENT_ID,
  },
};
